import { render, staticRenderFns } from "./PointsViewer.vue?vue&type=template&id=304b8d66&"
import script from "./PointsViewer.vue?vue&type=script&lang=js&"
export * from "./PointsViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports